import { render, staticRenderFns } from "./TranslationModal.vue?vue&type=template&id=34bd8aa2&scoped=true"
import script from "./TranslationModal.vue?vue&type=script&lang=js"
export * from "./TranslationModal.vue?vue&type=script&lang=js"
import style0 from "./TranslationModal.vue?vue&type=style&index=0&id=34bd8aa2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34bd8aa2",
  null
  
)

export default component.exports